import { ReactNode, FC } from 'react';
import { Col, Row } from 'antd';

import { KeyTextI } from '~src/interfaces/translate.interface';

import * as SC from './threeColsHeader.sc';

interface Props {
  supTitle?: KeyTextI;
  title?: KeyTextI;
  description?: KeyTextI;
  children?: ReactNode;
  leftColChildren?: ReactNode;
  rightColChildren?: ReactNode;
}

const ThreeColsHeader: FC<Props> = ({
  leftColChildren = null,
  supTitle,
  title,
  description,
  rightColChildren = null,
  children = null,
}) => (
  <SC.HeaderContainer>
    <Row gutter={30} align="middle" style={{ minHeight: 223 }}>
      <Col lg={4} sm={6}>
        {leftColChildren}
      </Col>
      <Col lg={16} sm={12}>
        <SC.TitleContainer>
          {supTitle && <SC.SupTitle data-translations={supTitle.key}>{supTitle.txt}</SC.SupTitle>}
          {title && <SC.ItemTitle data-transition={title.key}>{title.txt}</SC.ItemTitle>}
          {description && <SC.ItemDescription data-transition={description.key}>{description.txt}</SC.ItemDescription>}
        </SC.TitleContainer>
      </Col>
      <Col lg={4} sm={6}>
        <SC.RightCol>{rightColChildren}</SC.RightCol>
      </Col>
    </Row>
    {children}
  </SC.HeaderContainer>
);

export default ThreeColsHeader;
